import apiClient from "../clients/apiClient";
import { safeRequest } from "../safeRequest";

export const CategoriesService = {
  async get() {
    return safeRequest(
      apiClient.get("/categories").then((response) => response.data),
    );
  },
  async create(payload) {
    return safeRequest(
      apiClient.post("/categories", payload).then((response) => response.data),
    );
  },
  async delete(categoryId) {
    try {
      const response = await apiClient.delete(`/categories/${categoryId}`);
      return { status: response.status, data: null, message: null };
    } catch (error) {
      return {
        status: error?.response?.status || 500,
        data: error?.response?.data || null,
        message: error?.response?.data?.message || error?.message || "Erro desconhecido",
      };
    }
  },
};
